module.exports = __webpack_public_path__ + "static/media/navySwap.295f92ed.svg";